import AccountEdit from './account-edit/account-edit.vue';

export default {
  name: 'account-info',
  components: {
    AccountEdit,
  },
  data() {
    return {
      editAccountName: false,
    };
  },
  computed: {
    isAccountOwner() {
      return this.$store.getters['account/isAccountOwner'];
    },
    name() {
      return this.$store.getters['account/getActiveAccount'].name;
    },
    status() {
      return this.$store.getters['account/getActiveAccount'].status;
    },
    accountOwnerEmail() {
      return this.$store.getters['account/getActiveAccount'].accountOwnerEmail;
    },
  },
};
